/* eslint-disable */

<template>
  <div :class="{ 'cursor-drag': draggingCard === true }">
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Snippets</h3>
            <vue-draggable-container id="wordBank" class="list wordBank">
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">tar</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">until</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">zip</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">egrep</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">awk</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">$log</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">"$6"</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">pgrep</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">repeat</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">/tmp/tempfile</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">locate</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">filename</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">rar</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">then</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">"log.[1-6]$"</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">in</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">done</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">/var/log</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">for</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">xz</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">"$1"</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">sed</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">gzip</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">"$log.[1-6]$"</h5>
            <h5 class="dragBlock font-semibold cursor-pointer command-block script-token">while</h5>
          </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
        <section class="terminal">
          <div class="terminal-bar">
            <span class="terminal-dots" aria-hidden="true">
              <i></i>
              <i></i>
              <i></i>
            </span>
            <span class="terminal-title">script.sh</span>
          </div>
          <div class="terminal-body">
            <div class="script-line">
              <span class="script-text">#!/bin/bash</span>
            </div>
            <div class="script-line">
              <span class="script-text comment">#name: script.sh</span>
            </div>
            <div class="script-line">
              <span class="script-text">find /var/log -type f -maxdepth 1 | grep</span>
              <vue-draggable-container id="input0" class="answerStandard dropzone dropzoneStandard answer-bg script-slot" />
              <span class="script-text">&gt; /tmp/tempfile</span>
            </div>
            <div class="script-line">
              <vue-draggable-container id="input1" class="answerStandard dropzone dropzoneStandard answer-bg script-slot" />
              <span class="script-text">filename</span>
              <vue-draggable-container id="input2" class="answerStandard dropzone dropzoneStandard answer-bg script-slot" />
              <span class="script-text">$(cat</span>
              <vue-draggable-container id="input3" class="answerStandard dropzone dropzoneStandard answer-bg script-slot" />
              <span class="script-text">)</span>
            </div>
            <div class="script-line">
              <span class="script-text">do</span>
            </div>
            <div class="script-line">
              <vue-draggable-container id="input4" class="answerStandard dropzone dropzoneStandard answer-bg script-slot" />
              <span class="script-text">$filename</span>
            </div>
            <div class="script-line">
              <vue-draggable-container id="input5" class="answerStandard dropzone dropzoneStandard answer-bg script-slot" />
            </div>
          </div>
        </section>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.classList.add('currently-dragging-standard-command');
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
      this.$nextTick(() => {
        const bank = this.$el.querySelector('#wordBank');
        if (!bank) return;
        bank.querySelectorAll('.script-token').forEach((el) => {
          el.style.removeProperty('width');
          el.style.removeProperty('min-width');
          el.style.removeProperty('height');
        });
      });
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input0').textContent === '"log.[1-6]$"') {
        totalScore++;
        document.getElementById('input0').style.borderColor = '#77FAAE';
        document.getElementById('input0').style.backgroundColor = '#77FAAE';
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445';
        document.getElementById('input0').style.backgroundColor = '#fd4445';
      }
      if (document.getElementById('input1').textContent === 'for') {
        totalScore++;
        document.getElementById('input1').style.borderColor = '#77FAAE';
        document.getElementById('input1').style.backgroundColor = '#77FAAE';
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445';
        document.getElementById('input1').style.backgroundColor = '#fd4445';
      }
      if (document.getElementById('input2').textContent === 'in') {
        totalScore++;
        document.getElementById('input2').style.borderColor = '#77FAAE';
        document.getElementById('input2').style.backgroundColor = '#77FAAE';
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445';
        document.getElementById('input2').style.backgroundColor = '#fd4445';
      }
      if (document.getElementById('input3').textContent === '/tmp/tempfile') {
        totalScore++;
        document.getElementById('input3').style.borderColor = '#77FAAE';
        document.getElementById('input3').style.backgroundColor = '#77FAAE';
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445';
        document.getElementById('input3').style.backgroundColor = '#fd4445';
      }
      if (document.getElementById('input4').textContent === 'gzip') {
        totalScore++;
        document.getElementById('input4').style.borderColor = '#77FAAE';
        document.getElementById('input4').style.backgroundColor = '#77FAAE';
      } else {
        document.getElementById('input4').style.borderColor = '#fd4445';
        document.getElementById('input4').style.backgroundColor = '#fd4445';
      }
      if (document.getElementById('input5').textContent === 'done') {
        totalScore++;
        document.getElementById('input5').style.borderColor = '#77FAAE';
        document.getElementById('input5').style.backgroundColor = '#77FAAE';
      } else {
        document.getElementById('input5').style.borderColor = '#fd4445';
        document.getElementById('input5').style.backgroundColor = '#fd4445';
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.command-block {
  display: inline-flex;
  max-height: 100px;
  margin: 5px;
  padding: 10px;
  text-align: left;
  color: #fff;
  border: 1px solid #3f3f3f;
  background-color: #fd4445;
  border-radius: 5px;
}

.currently-dragging-standard-command {
  z-index: 99;
}

.terminal {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  border: 1px solid #2a3140;
  border-radius: 0.75rem;
  background: #0e1116;
}

.terminal-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 3rem;
  padding: 0.6rem 1rem;
  background: #1a1f27;
  border-bottom: 1px solid #2a3140;
}

.terminal-dots {
  display: inline-flex;
  gap: 0.4rem;

  i {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 999px;
    background: #3a4250;
    display: block;
  }
}

.terminal-title {
  color: #c5d0de;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 1.05rem;
}

.terminal-body {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  width: 100%;
  padding: 1.5rem 1.35rem 1.75rem;
  overflow-x: auto;
}

.script-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 0.85rem;
  min-width: 0;
  max-width: 100%;
}

.script-text {
  color: #e7eef8;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 1.35rem;
  line-height: 1.45;
}

.script-text.comment {
  color: #9aabbf;
}

.script-slot {
  display: inline-flex !important;
  flex: 0 0 auto;
  flex-direction: row !important;
  align-items: stretch !important;
  justify-content: stretch !important;
  box-sizing: border-box;
  width: max-content;
  min-width: 9rem;
  max-width: 100%;
  min-height: 3.5rem;
  height: auto !important;
  margin: 0;
  padding: 4px !important;
  overflow: hidden !important;
}

@media (max-width: 768px) {
  .script-text,
  .terminal-title {
    font-size: 1.1rem;
  }

  .script-slot {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

}
</style>

<style lang="scss">
#LegacySimulationRenderer .terminal .script-slot .script-token {
  display: flex !important;
  flex: 1 1 auto;
  align-items: center !important;
  justify-content: center !important;
  align-self: stretch !important;
  width: 100% !important;
  min-width: max-content;
  max-width: none !important;
  height: auto !important;
  min-height: 100%;
  margin: 0 !important;
  padding: 4px 8px !important;
  box-sizing: border-box;
  white-space: nowrap !important;
  word-break: normal !important;
  text-align: center !important;
}

#LegacySimulationRenderer .script-slot .script-token.draggable-source--is-dragging {
  opacity: 0 !important;
  visibility: hidden !important;
  width: max-content !important;
  min-width: 0 !important;
  max-width: 18rem !important;
  height: auto !important;
  min-height: 0 !important;
}

#LegacySimulationRenderer .script-token.draggable-source--is-dragging,
#LegacySimulationRenderer .answerStandard .script-token.draggable-source--is-dragging,
#LegacySimulationRenderer .draggable-mirror.script-token,
.draggable-mirror.script-token {
  width: max-content !important;
  min-width: 0 !important;
  max-width: 18rem !important;
  height: auto !important;
  min-height: 0 !important;
  transition: none !important;
}

#LegacySimulationRenderer #wordBank .script-token,
#LegacySimulationRenderer #wordBank .script-token.draggable-source--is-dragging,
.draggable-mirror.script-token {
  opacity: 1 !important;
  visibility: visible !important;
}
</style>
